import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import { MUTED, TREND_CHARTS, emptyTrendEntry } from "../constants";
import { SectionTitle } from "./SectionTitle";
import { SurchargeTrendCard } from "./SurchargeTrendCard";

export function SurchargeTrendsGrid({ data, isLoading }) {
  return (
    <section>
      <SectionTitle title="Surcharge Trends" icon={faChartColumn} rulesKey="surchargeTrends" />
      {isLoading ? (
        <div className="rounded-2xl bg-white border border-[#d6dfeb] px-6 py-12 text-center shadow-sm">
          <p className="text-sm font-semibold" style={{ color: MUTED }}>Loading trend data…</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {TREND_CHARTS.map(({ key, title }) => (
            <SurchargeTrendCard
              key={key}
              title={title}
              data={data[key] || emptyTrendEntry}
            />
          ))}
        </div>
      )}
    </section>
  );
}
